import { useEffect, useState, useRef } from 'react';
import { createSearchParams, useNavigate } from 'react-router';

import SearchBar from '../../components/searchBar';
import UserClientCards from './components/UserClientCards';

import { CircularProgress } from '@mui/material';
import { failure, unauthorized } from '../../types/api';
import { Errors } from '../../types/errors';

import useMediaQuery from '@mui/material/useMediaQuery';

import apiFunctions from '../../api';

import '../../index.css';

const UserClientLookup = () => {
  let timerRef = useRef<NodeJS.Timeout | null>(null);
  const [loading, setLoading] = useState(false);
  const [hasTyped, setHasTyped] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const [cards, setCards] = useState([]);
  const sm = useMediaQuery('(min-width: 882px)');
  const navigate = useNavigate();

  useEffect(() => {
    let subscribed = true;

    let backSearch = sessionStorage.getItem('searchVal');
    if (backSearch) {
      setHasTyped(true);
      setSearchValue(backSearch);
      sessionStorage.removeItem('searchVal');
    }

    const searchValues = async (searchValue: string) => {
      if (searchValue === '' || searchValue === undefined || searchValue === null) {
        clearCards();
        setLoading(false);
      } else {
        await apiFunctions.apiPost('OnDemand/GetUserClients', { SearchText: searchValue }).then((data) => {
          if (data === failure) {
            navigate({
              pathname: '/error',
              search: `?${createSearchParams({ errType: Errors.CallFailed })}`,
            });
          } else if (data === unauthorized) {
            navigate({
              pathname: '/error',
              search: `?${createSearchParams({ errType: Errors.Unauthorized })}`,
            });
          }

          if (typeof data === 'string') {
            clearCards();
          } else {
            setCards(data);
          }
          setLoading(false);
        });
      }
    };

    if (timerRef.current != null) {
      clearTimeout(timerRef.current);
    }
    if (hasTyped) {
      timerRef.current = setTimeout(async () => {
        if (subscribed) {
          setHasTyped(false);
          setLoading(true);
          clearCards();
          searchValues(searchValue);
        }
      }, 400);
    }

    return () => {
      subscribed = false;
    };
  }, [hasTyped, navigate, searchValue]);

  const clearCards = () => {
    setCards([]);
  };

  return (
    <div className="container">
      <SearchBar
        searchHeader="OnDemand User Client Search"
        searchLabel="UserClientUId, Email, DBA/Company Name, ApplicationUId, AAID, PURL ID"
        searchTooltipHtml="User must enter a valid UserClientUId, email, dba/company name, ApplicationUId, AAID, or PURL ID."
        searchValue={searchValue}
        setSearchValue={setSearchValue}
        clearCards={clearCards}
        setHasTyped={setHasTyped}
        sm={sm}
      />
      <br></br>
      <div className="searchVal">
        {searchValue !== '' ? (
          <h3>
            Search Results for <span className="blueText">{searchValue}</span>
          </h3>
        ) : (
          ''
        )}
      </div>
      <div className="wrapper">
        <div className="cards">
          <div className="loading">{loading && <CircularProgress />}</div>
          {cards.length > 0 && <UserClientCards cards={cards} />}
          {cards.length === 0 && !loading && <h2>No exact matches</h2>}
        </div>
      </div>
      <div className="resultTotal">{cards.length > 0 ? <h5>{cards.length} Result(s) Found</h5> : ''}</div>
    </div>
  );
};

export default UserClientLookup;
